<template>
  <group-details
    :id="orgId"
    :display-users-list="false"
    seat-edit-mode="REQUEST"
  />
</template>

<script>
import GroupDetails from '../../../components/access/GroupDetails';

export default {
  name: 'org-profile',
  components: {
    GroupDetails,
  },
  props: {
    user: {
      type: Object,
      required: true,
    }
  },
  computed: {
    orgId() {
      const groups = this.user['https://vrpatients.com/groups'];
      if (!groups) {
        return null;
      }
      return groups[0];
    }
  }
};
</script>

<style scoped>
</style>